import type { WebchatTranslations } from '.'

export const ar: WebchatTranslations = {
  'composer.placeholder': 'اكتب رسالتك...',
  'composer.sendButton.ariaLabel': 'زر إرسال الرسالة',
  'composer.voiceButton.ariaLabel': 'زر الإدخال الصوتي',
  'composer.fileButton.ariaLabel': 'زر رفع ملف',
  'composer.messageInput.ariaLabel': 'إدخال الرسالة',

  'fileAttachment.uploadError': 'خطأ في الرفع',
  'fileAttachment.fallbackExtension': 'ملف',
  'fileAttachment.removeButton.ariaLabel': 'زر إزالة الملف',

  'header.defaultBotName': 'بوت',
  'header.expandButton.ariaLabel': 'زر توسيع الرأس',
  'header.sound.enable': 'تفعيل أصوات المحادثة',
  'header.sound.disable': 'تعطيل أصوات المحادثة',

  'conversationHistory.title': 'المحادثات',
  'conversationHistory.empty': 'لم تبدأ أي محادثة بعد',
  'conversationHistory.newConversation': 'محادثة جديدة',
  'conversationHistory.sentAttachment': 'أرسل مرفقاً',
  'conversationHistory.showButton.ariaLabel': 'زر عرض المحادثات الأخيرة',

  'restartConversation.title': 'إنشاء محادثة جديدة',
  'restartConversation.description': 'سيؤدي هذا إلى مسح المحادثة الحالية وبدء محادثة جديدة.',
  'restartConversation.confirm': 'محادثة جديدة',
  'restartConversation.cancel': 'إلغاء',
  'restartConversation.button.ariaLabel': 'زر إعادة بدء المحادثة',

  'closeButton.ariaLabel': 'زر إغلاق الشات بوت',

  'feedback.title': 'ساعدنا على التحسين',
  'feedback.description': 'يرجى تقديم ملاحظاتك لمساعدتنا على التحسين.',
  'feedback.confirm': 'إرسال الملاحظات',
  'feedback.cancel': 'إلغاء',
  'feedback.placeholder': 'أخبرنا ما الخطأ الذي حدث...',

  'error.configuration': 'خطأ في الإعدادات',
  'error.bot': 'خطأ في البوت',
  'error.network': 'خطأ في الشبكة',
  'error.disconnected': 'غير متصل',
  'error.unexpected': 'خطأ غير متوقع',

  'dropdown.placeholder': 'اختر...',
}
